import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEOPageTitle from 'components/shared/SEOPageTitle';
import OrganizationList from 'components/admin-organizations/OrganizationList';
import AppBarContext from 'context/AppBarContext';

/**
 * Panel admin de organizaciones (venta masiva de planes). Lista + acceso al detalle.
 */
function OrganizationsAdminPage() {
  const { t } = useTranslation(['organizations', 'routes']);
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);
  const pageTitle = t('organizations', { ns: 'routes', defaultValue: 'Organizaciones' });

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(pageTitle);
  }, [pageTitle, setAppBarButton, setAppBarTitle]);

  return (
    <>
      <SEOPageTitle title={pageTitle} />
      <OrganizationList />
    </>
  );
}

export default OrganizationsAdminPage;
